export const educationData = [
    {
        id: 1,
        institution: 'SRM Institute of Science and Technology',
        course: 'B.Tech in Computer Science & Engineering',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'St. Agnes\' Convent School',
        course: 'Higher Secondary (ISC) ',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'St. Agnes\' Convent School',
        course: 'Senior Secondary (ICSE) ',
        startYear: '2008',
        endYear: '2019'
    },
]